import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import styles from "./donorInfo.module.css";
import Popu from "../../components/pop";
import Loader from "../../components/loader/Loader";
import { apiBaseURL } from "../../utils/axios";
import Avatar from "../../assets/User-avatar.png";
import { useSelector } from "react-redux";

function DonorInfoRequest() {
  const { id } = useParams();
  const userId = useSelector((state) => state.user.userId);
  const token = useSelector((state) => state.user.token);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behaviour: "smooth",
    });
  }, []);

  const [isLoading, setIsLoading] = useState(true);
  setTimeout(() => {
    setIsLoading(false);
  }, 2000);

  const [donor, setDonor] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const fetchDonor = () => {
      fetch(`${apiBaseURL}/v1/donors/` + id)
        .then((res) => res.json())
        .then((data) => {
          setDonor(data.user);
        });
    };
    fetchDonor();
  }, [id]);

  return (
    <section className="mx-auto max-w-[1380px]">
      <section className="shadow border-t-2 border-slate-200">
        {/* <div className={styles.imageContainer}> */}
        <div className="flex justify-center items-center text-center py-32 lg:px-4 px-8">
          {" "}
          <p className=" text-[#f6655f] text-4xl leading-normal font-bold">
            DONOR INFO{" "}
          </p>
        </div>
      </section>

      {isLoading && <Loader />}
      {!isLoading
        ? donor && (
            <div className={`${styles.findDonor} bg-transparent shadow-xl`}>
              <div className={`${styles.imgHolder}`}>
                <img
                  className={styles.image}
                  src={donor.avater || Avatar}
                  alt={donor.firstname}
                  onError={(event) => {
                    event.target.src =
                      "https://180dc.org/wp-content/uploads/2022/04/Blank-Avatar-300x262.png";
                    event.onerror = null;
                  }}
                />
                <div className=" mt-6">
                  <h5 className={`${styles.userName} text-red-500 text-xl`}>
                    {donor.firstname} {donor.lastname}
                  </h5>
                </div>
                {/* <p className="font-semibold profileNumber">#1229</p> */}
              </div>
              <div className={styles.donorCard}>
                <div className={styles.donorLocWrap}>
                  <p className={styles.donorLocTop}>Location</p>
                  <p
                    className={`${styles.donorLocation} first-letter:uppercase`}
                  >
                    {donor.state} State
                  </p>
                  <p
                    className={`${styles.donorLocation} first-letter:uppercase`}
                  >
                    {donor.city}
                  </p>
                </div>
                <div className="border-white border-y p-3 mb-5 border-opacity-50">
                  <p className="opacity-50 font-normal mb-5">Availability</p>
                  <h5 className="text-white">Available</h5>
                </div>
                <div className={styles.bloodTypeWrap}>
                  <p className={styles.bloodType}>{donor.bloodType}</p>
                </div>
              </div>

              {token && userId === id ? null : (
                <div className={`${styles.button} hover:bg-red-600`}>
                  <div
                    className={styles.center}
                    onClick={() => {
                      setShow(true);
                    }}
                  >
                    <button className={`${styles.fontWeight} `}>Request</button>
                  </div>

                  <Popu
                    onClose={() => setShow(false)}
                    show={show}
                    donor={donor}
                    donorId={id}
                  />
                </div>
              )}
            </div>
          )
        : null}
    </section>
  );
}

export default DonorInfoRequest;
